import React from "react";
import Paper from "@mui/material/Paper";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
const Bio = ()=> {
return (
    <>
    <Container maxWidth="md">
    <Grid item xs= {12} sx={{display:"flex" ,marginTop:"3rem"}} >
            <Typography variant="h3" component="div" sx={{ display: "flex", justifyContent: "center" , color:"white" }}>
                Omar Hussain 
            </Typography>
    </Grid>
    <Grid item xs={12}>
            <Typography variant="h6" component="div" sx={{color:"white"}}>
               (Developer/Designer/Gamer) 
            </Typography>

    </Grid> 
    <Grid item xs={12} sx={{display:"flex" , marginTop:"3rem"}}>
        <Paper sx={{ backgroundColor:"transparent", width:"70%"}}>
            <Typography variant="h5" component="div" sx={{display:"flex"  , color:"white" , padding:".5rem"}}>
                Work:
            </Typography>
            <Typography variant="h6" component="div" sx={{display:"flex"  , color:"white" , padding:"20px" }}>
                omar is a front-end developer based in cairo with a passion for building digital service/stuff he wants. He has  a knack for all things  launching products , from designing all the way to solving real-life problems with code. When not online he loves gaming and hanging out with friends.
            </Typography>
        </Paper>
    </Grid>
    </Container>
    </>
)
}
export default Bio;
